type TemplateBrowserAllowedFeatureType = Partial<{
	'template-browser': {
		'space-picker-disabled': boolean;
	};
}>;

export type EnableRedirectionAllowedFeatureType = Partial<{
	'enable-redirection': {
		'cross-site-tenant-id': string;
	};
}>;

export type ObjectAllowedFeaturesType =
	| string
	| TemplateBrowserAllowedFeatureType
	| EnableRedirectionAllowedFeatureType;

export const isRedirectionEnabled = (feature: ObjectAllowedFeaturesType): boolean => {
	if (typeof feature === 'object') {
		return 'enable-redirection' in feature;
	}

	if (typeof feature === 'string') {
		try {
			const parsedFeature = JSON.parse(feature);
			return (
				parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature
			);
		} catch (error) {
			return false;
		}
	}
	return false;
};

export const getCrossSiteTenantIdFromAllowedFeature = (
	feature?: string | EnableRedirectionAllowedFeatureType,
): string | undefined => {
	if (!feature) {
		return undefined;
	}

	if (typeof feature === 'string') {
		try {
			const parsed = JSON.parse(feature);
			return parsed['enable-redirection']?.['cross-site-tenant-id'];
		} catch (error) {
			return undefined;
		}
	}
	return feature['enable-redirection']?.['cross-site-tenant-id'];
};
